import { Box, Button, Typography } from '@mui/material';

interface QuestionsHeaderProps {
    questionsExist: boolean;
    onEdit: () => void;
}

const QuestionsHeader: React.FC<QuestionsHeaderProps> = ({ questionsExist, onEdit }) => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1.5 }}>
            <Typography variant="h3">Project questions</Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {questionsExist && (
                    <Button variant="outlined" color="primary" size="small" onClick={onEdit} sx={{ minWidth: 'auto' }}>
                        Edit
                    </Button>
                )}
            </Box>
        </Box>
    );
};

export default QuestionsHeader;
